/* SpawnAnything — pause menu on Escape during a battle (user request: a way back to the main menu while playing).
   Pauses a single-player battle while open (multiplayer keeps running), resumes on "Weiter" / Escape. The buttons
   only call the game's existing actions (deps). */
import './pauseMenu.css';

/** deps: { pause() -> resume fn | null, setup(), rematch(), settings(), mainMenu(), canRematch(), mode() -> '' | 'bet' | 'mp',
    forfeit() (bet: give up, the stake is lost), leaveMp() } */
export function createPauseMenu(deps) {
  const el = document.createElement('div');
  el.className = 'aw-pause'; el.hidden = true;
  el.innerHTML = `<div class="aw-pause-box" role="dialog" aria-modal="true" aria-labelledby="pauseT">
    <h2 id="pauseT">Pause</h2>
    <button type="button" class="go" data-p="resume"><i class="ti ti-player-play" aria-hidden="true"></i> Weiter</button>
    <button type="button" class="ghost" data-p="setup"><i class="ti ti-layout-sidebar-left-expand" aria-hidden="true"></i> Aufstellung ändern</button>
    <button type="button" class="ghost" data-p="rematch"><i class="ti ti-refresh" aria-hidden="true"></i> Nochmal</button>
    <button type="button" class="ghost" data-p="settings"><i class="ti ti-settings" aria-hidden="true"></i> Einstellungen</button>
    <button type="button" class="ghost" data-p="menu"><i class="ti ti-home" aria-hidden="true"></i> Hauptmenü</button>
    <button type="button" class="ghost" data-p="forfeit" hidden><i class="ti ti-flag" aria-hidden="true"></i> Wette aufgeben <small>(Einsatz verloren)</small></button>
    <button type="button" class="ghost" data-p="leaveMp" hidden><i class="ti ti-door-exit" aria-hidden="true"></i> Mehrspieler verlassen</button>
    <p class="aw-pause-hint">Esc: weiter</p>
  </div>`;
  document.body.appendChild(el);
  let resume = null;
  function open() {
    if (!el.hidden) return;
    el.hidden = false; resume = deps.pause ? deps.pause() : null;
    // betting and multiplayer have their own way out: no setup / restart / main menu behind their back
    const m = deps.mode ? deps.mode() : '', q = k => el.querySelector(`[data-p=${k}]`);
    q('rematch').hidden = !!m || (deps.canRematch ? !deps.canRematch() : false);
    q('setup').hidden = q('menu').hidden = !!m;
    q('forfeit').hidden = m !== 'bet'; q('leaveMp').hidden = m !== 'mp';
    el.querySelector('[data-p=resume]').focus();
  }
  function close(keepPaused) {
    if (el.hidden) return;
    el.hidden = true; const r = resume; resume = null;
    if (!keepPaused) r?.();
    return keepPaused ? r : null; // the caller resumes later (settings: when its window closes)
  }
  el.addEventListener('pointerdown', e => { if (e.target === el) close(); });
  el.querySelectorAll('[data-p]').forEach(b => b.addEventListener('click', () => {
    const k = b.dataset.p;
    if (k === 'resume') return close();
    const later = close(k === 'settings' || k === 'forfeit'); // settings: stays paused until its window closes
    if (k === 'setup') deps.setup();
    else if (k === 'rematch') deps.rematch();
    else if (k === 'settings') deps.settings(later);
    else if (k === 'menu') deps.mainMenu();
    else if (k === 'forfeit') deps.forfeit();
    else if (k === 'leaveMp') deps.leaveMp();
  }));
  return { open, close, toggle: () => (el.hidden ? open() : close()), get isOpen() { return !el.hidden; } };
}
